import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, HostBinding, OnInit } from '@angular/core';
import { ThemeService } from '../../../services/theme.service';
import { ElementDataRecordView, ElementService } from '../../service/element.service';
import ace from 'ace-builds';
@Component({
	selector: 'common-params-recordview-fetch-sql',
	templateUrl: './params-recordview-fetch-sql.component.html',
	styleUrls: ['./params-recordview-fetch-sql.component.scss']
})
export class ParamsRecordviewFetchSQLComponent implements OnInit {
	@HostBinding('class.recordview-fetchSQL') hostClass = true;
	public svr = this.elementSvr.data.recordview as ElementDataRecordView;
	constructor(public elementSvr: ElementService, public theme: ThemeService) {}
	options: any = { maxLines: 12, printMargin: false };
	dataColumns = true;
	startCheck = false;
	messageShow = false;
	ngOnInit() {
		ace.config.set('basePath', '/front/assets/ace-builds/src-min-noconflict');
	}

	genSQL() {
		this.svr.Params.Sql = `<<if eq "oci8" .Driver>>
		<<if ge .Limit 0>>
		SELECT * FROM(
		<<end>>
			SELECT <<if .Columns>><<.Columns>><<else>>*<<end>>
			FROM ${this.svr.Params.TableName}
			<<if .Where>>WHERE <<.Where>><<end>>
			<<if .OrderBy>>ORDER BY <<.OrderBy>><<end>>
		<<if ge .Limit 0>>
		)WHERE ROWNUM<=<<.Limit>>
		<<end>>
	<<else>>
		SELECT <<if .Columns>><<.Columns>><<else>>*<<end>>
		FROM  ${this.svr.Params.TableName}
		<<if .Where>>WHERE <<.Where>><<end>>
		<<if .OrderBy>>ORDER BY <<.OrderBy>><<end>>
		<<if ge .Limit 0>>LIMIT <<.Limit>><<end>>
	<<end>>`;
	}
	rebuildColumns() {
		this.elementSvr.back
			.checkSQL({
				DB: this.svr.Params.DB,
				Table: this.svr.Params.TableName,
				ManualPage: this.svr.Params.ManualPage,
				SQL: this.svr.Params.Sql
			})
			.subscribe(v => {
				this.svr.SQLCheckError = v.Error;
				if (!this.svr.SQLCheckError) {
					this.svr.Params.AllColumns = v.Columns;
				}
			});
	}
	drop(event: CdkDragDrop<string[]>) {
		moveItemInArray(this.svr.Params.AllColumns, event.previousIndex, event.currentIndex);
		const FieldChange = [];
		this.svr.Params.AllColumns.forEach(v => {
			if (this.svr.Params.UniqueField.includes(v.Name)) {
				FieldChange.push(v.Name);
			}
		});
		this.svr.Params.UniqueField = FieldChange;
	}
	checkSQL() {
		this.startCheck = true;
		this.svr.checkSQL().subscribe(() => {
			this.startCheck = false;
			this.messageShow = true;
		});
	}
}
